import { render, staticRenderFns } from "./NumbersAndSignsKeyboard.vue?vue&type=template&id=ba67fb74&scoped=true&"
import script from "./NumbersAndSignsKeyboard.vue?vue&type=script&lang=ts&"
export * from "./NumbersAndSignsKeyboard.vue?vue&type=script&lang=ts&"
import style0 from "./NumbersAndSignsKeyboard.vue?vue&type=style&index=0&id=ba67fb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba67fb74",
  null
  
)

export default component.exports